import ErrorElement from "../error/ErrorElement";

export default function ErrorPage() {

    return <ErrorElement />
};
